export interface DeferredData<T> {
  loading: boolean;
  unavailable: boolean;
  error?: string;
  data?: T;
}

/**
 * Creates a deferred data state indicating that the backend 
 * endpoint for this feature is not yet available or incomplete.
 */
export function createDeferredUnavailable<T>(): DeferredData<T> {
  return {
    loading: false,
    unavailable: true,
  };
}

export function createDeferredData<T>(data: T): DeferredData<T> {
  return {
    loading: false,
    unavailable: false,
    data,
  };
}

export function createDeferredLoading<T>(): DeferredData<T> {
  return {
    loading: true,
    unavailable: false,
  };
}

export function createDeferredError<T>(error: string): DeferredData<T> {
  return {
    loading: false,
    unavailable: false,
    error,
  };
}
